import React from "react";

const IntroSection = ({ invitation, fontStyleMap }) => {
  if (!invitation?.message) {
    return null;
  }

  return (
    <section className="fw-section fw-intro">
      <div className="fw-intro-inner">
        <p
          className="fw-intro-heading"
          style={{ ...(fontStyleMap.subtitle || {}) }}
        >
          Позиваме ве на нашата свадба
        </p>
        <p
          className="fw-intro-message"
          style={{ ...(fontStyleMap.body || {}) }}
        >
          {invitation.message}
        </p>
      </div>
    </section>
  );
};

export default IntroSection;

